export default __webpack_public_path__ + "static/Transform-7671d1d6ca658f4a127f6bd009fda88d.png";